import script from "./PaymentStatusBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusBar.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusBar.vue?vue&type=style&index=0&id=cc0f524e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc0f524e"]])

export default __exports__